export default __webpack_public_path__ + "static/media/youtube.bcae2122.svg";